import { useCourse } from './CourseContext';

export default function CoursesModeDetailsFooter({ onSave, onClose }) {
    const course = useCourse();
    return (
        <div className="mode-details-footer">
            <button onClick={onClose}>Cancel</button>
            <button onClick={() => onSave(course)}>Save</button>
        </div>
    );
}
